<template>
  <div class="w-100">
    <v-tabs v-model="tab">
      <v-tab v-for="(item, index) in items" :key="index" :value="index">
        {{ item.label }}
      </v-tab>
    </v-tabs>
    <v-window v-model="tab">
      <v-window-item
        class="bg-surface-variant color-on-surface-variant pa-4"
        v-for="(item, index) in items"
        :key="index"
        :value="index"
      >
        <ContentDoc :path="item.path" />
      </v-window-item>
    </v-window>
  </div>
</template>

<script setup>
const tab = ref(null)

defineProps({
  items: {
    type: Array,
    default: () => [],
  },
})
</script>
